/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { BubbleMenu } from "@tiptap/react";
import { useUpdateDocument } from "./use-update-document";
import { DocumentSettingsDialog } from "cms/rich-text/simplicity-composer-tiptap/document/document-settings-dialog";

const DocumentBubbleMenu = () => {
    
    const markType = "doclink";
    const { findSelection } = useUpdateDocument();
    
    const shouldShow = (properties) => {
        // const { editor, view, state, oldState, from, to } = properties
        const { editor } = properties;
        findSelection();
        return editor.isActive(markType);
    };
    
    return (
        // BubbleMenu will fail to remove correctly without a wrapping div
        // https://github.com/ueberdosis/tiptap/issues/2658#issuecomment-1312664934
        <div>
            <BubbleMenu
                updateDelay={100}
                shouldShow={shouldShow}
                tippyOptions={{
                    placement: "bottom",
                    zIndex: 100,
                    maxWidth: "800px",
                }}
            >
                <DocumentSettingsDialog />
                
            </BubbleMenu>
        </div>
    );
};
export { DocumentBubbleMenu };
